import { render, staticRenderFns } from "./contractChangeDetailsList.vue?vue&type=template&id=5f31fe83&scoped=true"
import script from "./contractChangeDetailsList.vue?vue&type=script&lang=js"
export * from "./contractChangeDetailsList.vue?vue&type=script&lang=js"
import style0 from "./contractChangeDetailsList.vue?vue&type=style&index=0&id=5f31fe83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31fe83",
  null
  
)

export default component.exports